import { render, staticRenderFns } from "./OfflineFeature.vue?vue&type=template&id=8c07de9a&scoped=true"
import script from "./OfflineFeature.vue?vue&type=script&lang=js"
export * from "./OfflineFeature.vue?vue&type=script&lang=js"
import style0 from "./OfflineFeature.vue?vue&type=style&index=0&id=8c07de9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c07de9a",
  null
  
)

export default component.exports